namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoiceHdRow {
        Id?: number;
        DocNo?: string;
        DocDate?: string;
        DocType?: Docfg;
        RefDocNo?: string;
        RefDocDate?: string;
        ConcatRefDocNo1?: string;
        ShopId?: string;
        MbId?: string;
        TaxInvNameId?: number;
        TaxInvName?: string;
        TaxInvAddressLine1?: string;
        TaxInvAddressLine2?: string;
        TaxInvAddressLine3?: string;
        TaxId?: string;
        TelNo?: string;
        SalesVatType?: string;
        GrossAmt?: number;
        DiscountAmt?: number;
        ChargeAmt?: number;
        SumDisChargeAmt?: number;
        NetAmt?: number;
        NetSalesNonVat?: number;
        NetSalesExVat?: number;
        NetSalesNormal?: number;
        VatAmt?: number;
        TaxInvoiceAmt?: number;
        Remark?: string;
        RefTaxInvoice?: string;
        RefTaxInvoiceAmt?: number;
        NewTaxInvoiceAmt?: number;
        TaxInvoiceAmtDiff?: number;
        NoOfPrint?: number;
        PostFg?: confirm;
        CancelFg?: CancelFgstatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        RefTaxInvoiceDate?: string;
        ErpAutoGenStamp?: string;
        DtList?: PsTaxInvoiceDtRow[];
        CusTaxTypeFg?: number;
        TaxBranchName?: string;
        TaxBranchNo?: string;
        TaxPostalCode?: string;
        TaxCountryCode?: string;
        TaxEmail?: string;
        PurposeCode?: string;
        PurposeRemark?: string;
        RefundId?: number;
        RefundFg?: number;
    }

    export namespace PsTaxInvoiceHdRow {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.PsTaxInvoiceHd';
        export const lookupKey = 'PsTaxInvoiceHdRow';

        export function getLookup(): Q.Lookup<PsTaxInvoiceHdRow> {
            return Q.getLookup<PsTaxInvoiceHdRow>('PsTaxInvoiceHdRow');
        }
        export const deletePermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';
        export const insertPermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';
        export const readPermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:View';
        export const updatePermission = '1POSBASE:ใบกำกับภาษี:ออกใบกำกับภาษี:Modify';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            DocDate = "DocDate",
            DocType = "DocType",
            RefDocNo = "RefDocNo",
            RefDocDate = "RefDocDate",
            ConcatRefDocNo1 = "ConcatRefDocNo1",
            ShopId = "ShopId",
            MbId = "MbId",
            TaxInvNameId = "TaxInvNameId",
            TaxInvName = "TaxInvName",
            TaxInvAddressLine1 = "TaxInvAddressLine1",
            TaxInvAddressLine2 = "TaxInvAddressLine2",
            TaxInvAddressLine3 = "TaxInvAddressLine3",
            TaxId = "TaxId",
            TelNo = "TelNo",
            SalesVatType = "SalesVatType",
            GrossAmt = "GrossAmt",
            DiscountAmt = "DiscountAmt",
            ChargeAmt = "ChargeAmt",
            SumDisChargeAmt = "SumDisChargeAmt",
            NetAmt = "NetAmt",
            NetSalesNonVat = "NetSalesNonVat",
            NetSalesExVat = "NetSalesExVat",
            NetSalesNormal = "NetSalesNormal",
            VatAmt = "VatAmt",
            TaxInvoiceAmt = "TaxInvoiceAmt",
            Remark = "Remark",
            RefTaxInvoice = "RefTaxInvoice",
            RefTaxInvoiceAmt = "RefTaxInvoiceAmt",
            NewTaxInvoiceAmt = "NewTaxInvoiceAmt",
            TaxInvoiceAmtDiff = "TaxInvoiceAmtDiff",
            NoOfPrint = "NoOfPrint",
            PostFg = "PostFg",
            CancelFg = "CancelFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            RefTaxInvoiceDate = "RefTaxInvoiceDate",
            ErpAutoGenStamp = "ErpAutoGenStamp",
            DtList = "DtList",
            CusTaxTypeFg = "CusTaxTypeFg",
            TaxBranchName = "TaxBranchName",
            TaxBranchNo = "TaxBranchNo",
            TaxPostalCode = "TaxPostalCode",
            TaxCountryCode = "TaxCountryCode",
            TaxEmail = "TaxEmail",
            PurposeCode = "PurposeCode",
            PurposeRemark = "PurposeRemark",
            RefundId = "RefundId",
            RefundFg = "RefundFg"
        }
    }
}
